import List from "./List";
import Form from "./Form";

interface PropsPlan {
  action: "list" | "create" | "duplicate" | "edit";
}

export default function PlansPage(props: PropsPlan) {
  return (
    <div className="content_page">
      {(!props.action || props.action === "list") && <List />}

      {props.action &&
        ["create", "edit", "duplicate"].includes(props.action) && (
          <Form action={props.action} />
        )}
    </div>
  );
}
